const tab_sections = {
    overview: 'Overview',
    authentication: 'Authentication',
    authorization: 'Authorization',
    users: 'Users',
    developer: 'Developer',
    tenant: 'Tenant',
};
export default Object.freeze(tab_sections);
